import {
  type GraphViewRequestBodyBase,
  graphOverlayToRequest,
} from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';
import { extractPresetSettings } from 'components/Graph/helpers/extractPresetSettings';
import { getNodePositionsFromState } from 'components/Graph/helpers/getNodePositions';
import { applyCollapsedNodeGroupsToViewRequestBody } from './applyCollapsedNodeGroupsToViewRequestBody';
import { getHiddenNodeSns } from './getHiddenNodes';
import { getViewAttributes } from './getViewAttributes';

export const createGraphViewRequestBody = (
  name: string,
  state: GraphState,
): GraphViewRequestBodyBase => {
  const {
    graph,
    graphMetadata,
    layoutSettings: { preset: topologyPreset },
    overlay,
    pathlookup,
  } = state;

  const { preset, parameters } = getViewAttributes(
    graphMetadata,
    pathlookup,
    topologyPreset,
  );

  return applyCollapsedNodeGroupsToViewRequestBody(graph, {
    hiddenNodes: getHiddenNodeSns(graph),
    name,
    overlay: graphOverlayToRequest(overlay),
    parameters,
    positions: getNodePositionsFromState(state),
    settings: extractPresetSettings(preset),
  });
};
